
export default
    name: 'live-results'
    props:
        heats: {type: Object, required: true}
        race_id: Number
        race_type: {type: String, default: 'linear'}
        columns: Number
    data: ->
        refresh_at: 20
        maxColumnWidth: '450px'

    computed:
        sortedHeats: ->
            Object.values(@heats).slice().sort((a, b) => a.rank_abs - b.rank_abs)
        styleColumns: ->
            {'column-count': @columns,'column-width': @maxColumnWidth}

    channels:
        LiveHeatsChannel:
            received: (data) ->
                if data.heat? && @heats[data.heat.bib]?
                    @$set(@heats, data.heat.bib, data.heat)
                if data.heats?
                    @$set(@, 'heats', data.heats)
                if data.action?
                    @refresh() if 'update' == data.action

    mounted: ->
        if @race_id?
            @$cable.subscribe({ channel: 'LiveHeatsChannel', race_id: @race_id })

    methods:
        refresh: ->
            @axios.get(window.location.href)
                .then (res) => @$emit('input', res.data.heats)
                .catch (e) -> console.log e

